import React, { useEffect, useState } from "react";
import "./ConfirmAdminDelete.scss";
import { useForm } from "react-hook-form";
import OTPInputField from "../UserFormComponents/OTPInputField/OTPInputField";
import { deleteAdminAccount, resendUserOtp } from "../../api/auth";
import { toast } from "react-toastify";
import CustomButton from "../CustomButton/CustomButton";
import { useNavigate } from "react-router-dom";
import ROUTES from "../../constants/routes";

const ConfirmAdminDelete = ({ open, setOpen, handleComplete, user }) => {
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm();

  const navigate = useNavigate();

  const [submitting, setSubmitting] = useState(false);
  const [timer, setTimer] = useState(0);

  useEffect(() => {
    let interval;

    if (timer > 0) {
      interval = setInterval(() => {
        setTimer((prevTimer) => prevTimer - 1);
      }, 1000);
    } else {
      setTimer(0);
      clearInterval(interval);
    }

    return () => clearInterval(interval);
  }, [timer]);

  useEffect(() => {
    setTimer(60);
  }, [open]);

  const handleVerifyOTP = async (data) => {
    if (!submitting && user?.id) {
      setSubmitting(true);
      const credentials = {
        id: user?.id,
        otp: data?.otp ? Number(data?.otp) : null,
      };
      deleteAdminAccount(credentials)
        .then((res) => {
              toast.dismiss(); toast.success("Admin account deleted successfully.");

          handleComplete();
          navigate(ROUTES.login.path);
        })
        .catch((err) => {
          if (err?.response?.data?.message) {
                  toast.dismiss(); toast.error(err?.response?.data?.message);
          } else {
                  toast.dismiss(); toast.error("OTP verification failed!");
          }
        })
        .finally(() => {
          setSubmitting(false);
        });
    }
  };

  const handleResendOTP = async () => {
    if (timer === 0 && user?.email && !submitting) {
      setSubmitting(true);
      let captchaToken = "";
      let source = "mobile";
      const credentials = {
        email: user?.email,
        isUserVerify: false,
        captchaToken: captchaToken,
        source: source,
        isAdminDelete: true,
      };

      resendUserOtp(credentials)
        .then((res) => {
          if (res.data?.message) {
                  toast.dismiss(); toast.success(res.data?.message);
          } else {
                  toast.dismiss(); toast.success("OTP is sent to admin's email address.");
          }
          if (res.data?.resend_timer) {
            setTimer(Number(res.data?.resend_timer));
          } else {
            setTimer(60);
          }
        })
        .catch((err) => {
          if (err?.response?.data?.message) {
                  toast.dismiss(); toast.error(err?.response?.data?.message);
          } else {
                  toast.dismiss(); toast.error("OTP resend failed! Please try again later.");
          }
          if (err?.response?.data?.resend_timer) {
            setTimer(Number(err?.response?.data?.resend_timer));
          } else {
            setTimer(60);
          }
        })
        .finally(() => {
          setSubmitting(false);
        });
    }
  };
  return (
    <>
      <form
        onSubmit={handleSubmit(handleVerifyOTP)}
        className={`confirm-handle-delete ${open ? "active" : ""}`}
      >
        <div className="heading">Confirmation OTP</div>
        <div className="inputs">
          <OTPInputField
            numberOfFields={5}
            setValue={setValue}
            name={"otp"}
            required={true}
            register={register}
            inputErrors={errors}
          />
        </div>

        <div className="buttons">
          <CustomButton
            name={"Confirm"}
            type={"submit"}
            color={"primary"}
            bigButton={true}
            disabled={submitting}
            handleSubmit={() => {}}
            loader={submitting}
          />
        </div>

        <p className="resend">
          Didn't you Receive any code?{" "}
          <span className={timer > 0 ? "danger" : ""} onClick={handleResendOTP}>
            {timer > 0 ? `RESEND CODE in ${timer} seconds` : "RESEND CODE"}
          </span>
        </p>
      </form>
      {open && (
        <div
          className="blur-back-upper"
          onClick={() => {
            !submitting && setOpen(false);
          }}
        ></div>
      )}
    </>
  );
};

export default ConfirmAdminDelete;
